import axios from "axios"
import { toast } from "react-toastify"
import { UrlApi } from "../Keys"
import moment from "moment/moment"

let loadingToast = null

const ToastLoading = (msj) => {
  loadingToast = toast.info(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: false,
    hideProgressBar: false,
    closeOnClick: false,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  })
}

const ToastSuccess = (msj) => {
  toast.success(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

const ToastError = (msj) => {
  toast.error(msj, {
    theme: "dark",
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    onOpen: () => {
      if (loadingToast !== null) {
        toast.dismiss(loadingToast)
      }
    },
  })
}

const dataInicial = {
  pgdColaborador: [],
  getPgdColaborador: false,
  pgdCicloFinalizado: [],
  getPgdCicloFinalizado: false,
  pgdEquipo: [],
  getPgdEquipo: false,
  pgdEquipoFinalizado: [],
  getPgdEquipoFinalizado: false,
  loadEstadoPGD: ""
}

const LOADING_PGD_COLABORADOR = "LOADING_PGD_COLABORADOR"
const PGD_COLABORADOR = "PGD_COLABORADOR"
const PGD_COLABORADOR_ERROR = "PGD_COLABORADOR_ERROR"

const LOADING_PGD_CICLOF = "LOADING_PGD_CICLOF"
const PGD_CICLO_FINALIZADO = "PGD_CICLO_FINALIZADO"
const PGD_CICLO_FINALIZADO_ERROR = "PGD_CICLO_FINALIZADO_ERROR"

const LOADING_PGD_EQUIPO = "LOADING_PGD_EQUIPO"
const PGD_EQUIPO = "PGD_EQUIPO"
const ERROR_PGD_EQUIPO = "ERROR_PGD_EQUIPO"

const LOADING_PGD_EQUIPO_FINALIZADO = "LOADING_PGD_EQUIPO_FINALIZADO"
const PGD_EQUIPO_FINALIZADO = "PGD_EQUIPO_FINALIZADO"
const ERROR_PGD_EQUIPO_FINALIZADO = "ERROR_PGD_EQUIPO_FINALIZADO"

const LOADING_NUEVO_ESTADO_PGD = "LOADING_NUEVO_ESTADO_PGD"
const EXITO_NUEVO_ESTADO_PGD = "EXITO_NUEVO_ESTADO_PGD"
const ERROR_NUEVO_ESTADO_PGD = "ERROR_NUEVO_ESTADO_PGD"

//Reducers
export default function pgdReducer(state = dataInicial, action) {
  switch (action.type) {
    case LOADING_PGD_COLABORADOR:
      return { ...state, getPgdColaborador: action.getPgdColaborador }
    case PGD_COLABORADOR:
      return { ...state, pgdColaborador: action.payload, getPgdColaborador: action.getPgdColaborador }
    case PGD_COLABORADOR_ERROR:
      return { ...state, getPgdColaborador: action.getPgdColaborador }
    case LOADING_PGD_CICLOF:
      return { ...state, getPgdCicloFinalizado: action.getPgdCicloFinalizado }
    case PGD_CICLO_FINALIZADO:
      return { ...state, pgdCicloFinalizado: action.payload, getPgdCicloFinalizado: action.getPgdCicloFinalizado }
    case PGD_CICLO_FINALIZADO_ERROR:
      return { ...state, getPgdCicloFinalizado: action.getPgdCicloFinalizado }
    case LOADING_PGD_EQUIPO:
      return { ...state, getPgdEquipo: action.getPgdEquipo }
    case PGD_EQUIPO:
      return { ...state, pgdEquipo: action.payload, getPgdEquipo: action.getPgdEquipo }
    case ERROR_PGD_EQUIPO:
      return { ...state, getPgdEquipo: action.getPgdEquipo }
    case LOADING_PGD_EQUIPO_FINALIZADO:
      return { ...state, getPgdEquipoFinalizado: action.getPgdEquipoFinalizado }
    case PGD_EQUIPO_FINALIZADO:
      return { ...state, pgdEquipoFinalizado: action.payload, getPgdEquipoFinalizado: action.getPgdEquipoFinalizado }
    case ERROR_PGD_EQUIPO_FINALIZADO:
      return { ...state, getPgdEquipoFinalizado: action.getPgdEquipoFinalizado }
    case LOADING_NUEVO_ESTADO_PGD:
      return { ...state, loadEstadoPGD: action.resultado }
    case EXITO_NUEVO_ESTADO_PGD:
      return { ...state, loadEstadoPGD: action.resultado }
    case ERROR_NUEVO_ESTADO_PGD:
      return { ...state, loadEstadoPGD: action.resultado }
    default:
      return { ...state }
  }
}

export const pgdColaborador = (token, fechaHoy, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_PGD_COLABORADOR,
    getPgdColaborador: false,
  })
  try {
    var entidad = "new_evaluaciondepgds"
    // var fetch =
    //   "<entity name='new_evaluaciondepgd'>" +
    //   "<attribute name='new_evaluaciondepgdid' />" +
    //   "<attribute name='new_name' />" +
    //   "<attribute name='new_ciclo' />" +
    //   "<attribute name='new_grupodeciclo' />" +
    //   "<attribute name='new_fechainicioautoevaluacion' />" +
    //   "<attribute name='new_fechavencimientoautoevaluacin' />" +
    //   "<attribute name='statuscode' />" +
    //   "<attribute name='new_estadodelaautoevaluacin' />" +
    //   "<attribute name='new_estadodelaevaluacindellder' />" +
    //   "<order attribute='new_name' descending='false' />" +
    //   "<filter type='and'>" +
    //   // "<condition attribute='new_fechainicioautoevaluacion' operator='on-or-before' value='{{fechaHoy}}' />" +
    //   // "<condition attribute='new_fechavencimientoautoevaluacin' operator='on-or-after' value='{{fechaHoy}}'/>" +
    //   "<condition attribute='new_autoevaluacion' operator='eq' value='1' />" +
    //   "</filter>" +
    //   "<link-entity name='new_ciclodepgd' from='new_ciclodepgdid' to='new_ciclo' visible='false' link-type='inner' alias='a_92669103c7c3eb11bacc002248378a00'>" +
    //   "<attribute name='new_perododepgdasociado' />" +
    //   "<attribute name='new_ciclo' />" +
    //   // "<filter type='and'>" +
    //   // "<condition attribute='new_fechahasta' operator='on-or-after' value='" +
    //   // fechaHoy +
    //   // "' />" +
    //   // "</filter>" +
    //   "</link-entity>" +
    //   "<link-entity name='new_empleado' from='new_empleadoid' to='new_evaluado' link-type='inner' alias='ab'>" +
    //   "<filter type='and'>" +
    //   "<condition attribute='new_usuarioportalrh' operator='eq' value='" +
    //   usuarioPortalRh +
    //   "' />" +
    //   "</filter>" +
    //   "</link-entity>" +
    //   "</entity>"
    var fetch =
      "<entity name='new_evaluaciondepgd'>" +
      "<attribute name='new_evaluaciondepgdid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_ciclo' />" +
      "<attribute name='new_grupodeciclo' />" +
      "<attribute name='new_fechainicioautoevaluacion' />" +
      "<attribute name='new_fechainicioevaluacindellider' />" +
      "<attribute name='new_fechainiciofeedback' />" +
      "<attribute name='new_fechavencimientoautoevaluacin' />" +
      "<attribute name='new_fechavencimientoevaluacindellider' />" +
      "<attribute name='new_fechavencimientofeedback' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='new_estadodelaautoevaluacin' />" +
      "<attribute name='new_estadodelaevaluacindellder' />" +
      "<attribute name='new_estadodelencuentrodefeedback' />" +
      "<attribute name='new_scoreglobaldeobjetivos' />" +
      "<attribute name='new_scoreglobaldedompetencias' />" +
      "<order attribute='new_name' descending='false' />" +
      "<filter type='and'>" +
        "<condition attribute='statecode' operator='eq' value='0' />" +
        "<condition attribute='statuscode' operator='in'>" +
          "<value>100000000</value>" +
          "<value>100000001</value>" +
          "<value>100000002</value>" +
        "</condition>" +
      "</filter>" +
      "<link-entity name='new_ciclodepgd' from='new_ciclodepgdid' to='new_ciclo' visible='false' link-type='inner' alias='a_92669103c7c3eb11bacc002248378a00'>" +
      "<attribute name='new_perododepgdasociado' />" +
      "<attribute name='new_ciclo' />" +
      "<filter type='and'>" +
      "<condition attribute='statuscode' operator='eq' value='1'/>" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_evaluado' link-type='inner' alias='ab'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='eq' value='" +
      usuarioPortalRh +
      "' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: PGD_COLABORADOR,
      payload: response.data,
      getPgdColaborador: true,
    })
  } catch (error) {
    dispatch({
      type: PGD_COLABORADOR_ERROR,
      getPgdColaborador: true,
    })
  }
}

export const pgdCicloFinalizado = (token, fechaHoy, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_PGD_CICLOF,
    getPgdCicloFinalizado: false,
  })

  try {
    var entidad = "new_evaluaciondepgds"
    var fetch =
      "<entity name='new_evaluaciondepgd'>" +
        "<attribute name='new_evaluaciondepgdid' />" +
        "<attribute name='new_name' />" +
        "<attribute name='new_ciclo' />" +
        "<attribute name='new_grupodeciclo' />" +
        "<attribute name='statuscode' />" +
        "<attribute name='new_estadodelaautoevaluacin' />" +
        "<attribute name='new_fechavencimientoautoevaluacin' />" +
        "<attribute name='new_estadodelaevaluacindellder' />" +
        "<attribute name='new_fechainicioautoevaluacion' />" +
        "<attribute name='new_estadofinaldelaevaluacindepgd' />" +
        "<order attribute='new_name' descending='false' />" +
        "<link-entity name='new_ciclodepgd' from='new_ciclodepgdid' to='new_ciclo' visible='false' link-type='inner' alias='ab'>" +
          "<attribute name='new_perododepgdasociado' />" +
          "<attribute name='new_ciclo' />" +
          "<attribute name='new_fechadesde' />" +
          "<attribute name='new_fechahasta' />" +
          "<filter type='and'>" +
          "<condition attribute='statuscode' operator='eq' value='100000000'/>" +
          "<condition attribute='new_fechadesde' operator='on-or-after' value='2023-04-01'/>" +
          "</filter>" +
          "</link-entity>" +
        "<link-entity name='new_empleado' from='new_empleadoid' to='new_evaluado' link-type='inner' alias='ae'>" +
          "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" +
            usuarioPortalRh +
            "' />" +
          "</filter>" +
        "</link-entity>" +
        "<link-entity name='annotation' from='objectid' to='new_evaluaciondepgdid' link-type='outer' alias='ac'>" +
          "<attribute name='annotationid' />" +
          "<attribute name='documentbody' />" +
          "<attribute name='filename' />" +
          "<attribute name='mimetype' />" +
        "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: PGD_CICLO_FINALIZADO,
      payload: response.data,
      getPgdCicloFinalizado: true,
    })
  } catch (error) {
    dispatch({
      type: PGD_CICLO_FINALIZADO_ERROR,
      getPgdCicloFinalizado: true,
    })
  }
}

export const pgdEquipoFetch = (token, fechaHoy, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_PGD_EQUIPO,
    getPgdEquipo: false,
  })

  try {
    var entidad = "new_evaluaciondepgds"
    var fetch =
      "<entity name='new_evaluaciondepgd'>" +
      "<attribute name='new_evaluaciondepgdid' />" +
      "<attribute name='new_estadodelaautoevaluacin' />" +
      "<attribute name='new_estadodelaevaluacindellder' />" +
      "<attribute name='new_estadodelencuentrodefeedback' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_ciclo' />" +
      "<attribute name='new_grupodeciclo' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='new_fechainicioautoevaluacion' />" +
      "<attribute name='new_fechainicioevaluacindellider' />" +
      "<attribute name='new_fechainiciofeedback' />" +
      "<attribute name='new_fechavencimientoautoevaluacin' />" +
      "<attribute name='new_fechavencimientoevaluacindellider' />" +
      "<attribute name='new_fechavencimientofeedback' />" +
      "<attribute name='new_evaluado' />" +
      "<attribute name='new_scoreglobaldeobjetivos' />" +
      "<attribute name='new_scoreglobaldedompetencias' />" +
      "<order attribute='new_name' descending='false' />" +
      "<filter type='and'>" +
        "<condition attribute='statecode' operator='eq' value='0' />" +
        "<condition attribute='statuscode' operator='in'>" +
          "<value>100000000</value>" +
          "<value>100000001</value>" +
          "<value>100000002</value>" +
        "</condition>" +
      "</filter>" +
      "<link-entity name='new_ciclodepgd' from='new_ciclodepgdid' to='new_ciclo' visible='false' link-type='inner' alias='a_92669103c7c3eb11bacc002248378a00'>" +
      "<attribute name='new_perododepgdasociado' />" +
      "<attribute name='new_ciclo' />" +
      "<filter type='and'>" +
      "<condition attribute='statuscode' operator='eq' value='1'/>" +
      "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_lder' link-type='inner' alias='ab'>" +
      "<filter type='and'>" +
      "<condition attribute='new_correoelectronico' operator='eq' value='" +
      usuarioPortalRh +
      "' />" +
      "</filter>" +
      "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: PGD_EQUIPO,
      payload: response.data,
      getPgdEquipo: true,
    })
  } catch (error) {
    dispatch({
      type: ERROR_PGD_EQUIPO,
      getPgdEquipo: true,
    })
  }
}

export const pgdEquipoFinalizadoFetch = (token, fechaHoy, usuarioPortalRh) => async (dispatch) => {
  dispatch({
    type: LOADING_PGD_EQUIPO_FINALIZADO,
    getPgdEquipoFinalizado: false,
  })

  try {
    var entidad = "new_evaluaciondepgds"
    var fetch =
      "<entity name='new_evaluaciondepgd'>" +
      "<attribute name='new_evaluaciondepgdid' />" +
      "<attribute name='new_name' />" +
      "<attribute name='new_ciclo' />" +
      "<attribute name='new_grupodeciclo' />" +
      "<attribute name='statuscode' />" +
      "<attribute name='new_evaluado' />" +
      "<attribute name='new_estadodelaautoevaluacin' />" +
      "<attribute name='new_fechavencimientoautoevaluacin' />" +
      "<attribute name='new_estadodelaevaluacindellder' />" +
      "<attribute name='new_fechainicioautoevaluacion' />" +
      "<attribute name='new_estadofinaldelaevaluacindepgd' />" +
      "<order attribute='new_name' descending='false' />" +
      "<link-entity name='new_ciclodepgd' from='new_ciclodepgdid' to='new_ciclo' visible='false' link-type='inner' alias='ab'>" +
        "<attribute name='new_perododepgdasociado' />" +
        "<attribute name='new_ciclo' />" +
        "<attribute name='new_fechadesde' />" +
        "<attribute name='new_fechahasta' />" +
        "<filter type='and'>" +
          "<condition attribute='statuscode' operator='eq' value='100000000'/>" +
          "<condition attribute='new_fechadesde' operator='on-or-after' value='2023-04-01'/>" +
        "</filter>" +
      "</link-entity>" +
      "<link-entity name='new_empleado' from='new_empleadoid' to='new_evaluado' link-type='inner' alias='ac'>" +
        "<link-entity name='new_empleado' from='new_empleadoid' to='new_reportaaid' link-type='inner' alias='ad'>" +
          "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='eq' value='" + usuarioPortalRh + "' />" +
          "</filter>" +
        "</link-entity>" +
      "</link-entity>" +
      "<link-entity name='annotation' from='objectid' to='new_evaluaciondepgdid' link-type='outer' alias='ae'>" +
        "<attribute name='annotationid' />" +
        "<attribute name='documentbody' />" +
        "<attribute name='filename' />" +
        "<attribute name='mimetype' />" +
      "</link-entity>" +
      "</entity>"

    const response = await axios.post(
      `${UrlApi}api/consultafetch`,
      {
        entidad: entidad,
        fetch: fetch,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    dispatch({
      type: PGD_EQUIPO_FINALIZADO,
      payload: response.data,
      getPgdEquipoFinalizado: true,
    })
  } catch (error) {
    dispatch({
      type: ERROR_PGD_EQUIPO_FINALIZADO,
      getPgdEquipoFinalizado: true,
    })
  }
}

export const nuevoEstadoPGD = (token, id, estadoCampo, estado) => async (dispatch) => {
  dispatch({
    type: LOADING_NUEVO_ESTADO_PGD,
    resultado: "LOADING",
  });
  ToastLoading("Procesando...")

  return new Promise((resolve, reject) => {
    if (token) {
      axios.put(`${UrlApi}api/hrfactors/evaluacionpgd`,
        {
          "new_evaluaciondepgdid": id,
          [estadoCampo]: estado,
        }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          dispatch({
            type: EXITO_NUEVO_ESTADO_PGD,
            resultado: "EXITO",
            payload: response.data,
          });

          ToastSuccess("PGD actualizado con éxito");
          resolve(response.data);
        })
        .catch((error) => {
          console.log(error);

          dispatch({
            type: ERROR_NUEVO_ESTADO_PGD,
            resultado: "ERROR",
          });

          ToastError(error.response.data);
          reject(error);
        });
    }
  });
};